import { WarningIcon as Warning } from "@packages/ds";
import styled from "styled-components";

import { semiBoldAlias } from "Libs/theme";

export const Border = styled.div`
  margin-top: 24px;
  border-radius: 2px;
  background-color: var(--section-snow-background-color, var(--snow));
`;

export const TextWrapper = styled.div`
  color: var(--section-ebony-light-color,var(--ebony-light));

  padding: 32px;
  margin-bottom: 32px;
  font-size: 14px;
  h4 {
    padding-top: 30px;
    margin-top: 30px;
    border-top: 1px solid #dedede;
  }
  .description {
    color: var(--section-ebony-light-color,var(--ebony-light));
    font-size: 15px;
  }
  ul {
    margin-bottom: 32px;
    li {
      margin-bottom: 4px;
      margin-left: -18px;
    }
  }

  pre {
    border: none;
    var(--section-dark-background-color,var(--dark));
    line-height: 40px;
    padding: 0 15;
    margin-right: 0;
    var(--section-snow-color,var(--snow));
  }
  .copy-to-clipboard {
    border: none;
    background: #1a192b;
    line-height: 40px;
    height: 40px;
    padding: 0 15px;
    border-radius: 0;
    font: 0/0 none;
    svg > g > g {
      var(--icon-snow-fill,var(--snow))
    }
    &:hover svg > g > g {
      var(--icon-color-primary-600-fill,var(--color-primary-600))
    }
  }
  .copied-message {
    border-radius: 0;
  }
`;

export const WarningText = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 16px;
  color: var(--section-ebony-light-color, var(--ebony-light));
  font-size: 14px;
  ${semiBoldAlias()};
  svg {
    margin-right: 8px;
  }
`;

export const WarningWrapper = styled.div`
  margin-bottom: 16px;
  display: flex;
`;

export const WarningIcon = styled(Warning)`
  margin-right: 20px;
`;

export const List = styled.ul`
  margin-bottom: 17px;
`;
